const pii = (value, hasPiiAccess = false, type = 'default') => {
  if (hasPiiAccess) return value
  if (!value) return ''

  switch (type) {
    case 'email':
      // john.doe@gmail.com -> j***.d***@gmail.com
      if (!value.includes('@')) return value.replace(/\D/g, '*')
      const [name, domain] = value.split('@')
      const maskedName = name
        .split('.')
        .map((part) => part.charAt(0) + '*'.repeat(part.length - 1))
        .join('.')
      return `${maskedName}@${domain}`

    case 'document':
      // 123.456.789-00 -> 123.***.***-**
      return value.replace(/(\d{3})\.(\d{3})\.(\d{3})-(\d{2})/, '$1.***.***-**')

    case 'phone':
      // (11) 98765-4321 -> (11) *****-4321
      return value.replace(/(\d{2})\)\s(\d{5})-(\d{4})/, '$1) *****-$3')

    default:
      // Default behavior: mask all numbers
      return value.replace(/\D/g, '*')
  }
}

export default pii
